/**
 * retripで扱うスポットの定義。
 *   poi, coord(緯度経度で指定した地点) などを想定
 * (現状MapPageでのみ使用)
 */
export default class Spot {
  constructor(spot) {
    this.spotName = spot.spotName;
    this.spotNameMultilang = spot.spotNameMultilang;
    this.spotId = spot.spotId;
    this.imageUrl = spot.imageUrl;
    this.categoryCode = spot.categoryCode;
    this.categoryName = spot.categoryName;
    this.roadType = spot.roadType;
    this.tripAdvisor = spot.tripAdvisor;
    this.coord = spot.coord ||
      {
        lat: spot.lat,
        lon: spot.lon,
      };
    this.address = spot.addressName || spot.address;
    this.addressCode = spot.addressCode;
    this.phone = spot.phone;
    this.catchCopy = spot.catchCopy;
    this.outline = spot.outline;
    this.openingHours = spot.openingHours;
    this.rainySpot = spot.rainySpot;
    this.wheelchairAccessible = spot.wheelchairAccessible;
    this.canUseWifi = spot.canUseWifi;
    this.parkingAvailable = spot.parkingAvailable;
    this.canUseCreditCard = spot.canUseCreditCard;
    this.canUsePlug = spot.canUsePlug;
    this.supportMultilang = spot.supportMultilang;
    this.supportVegan = spot.supportVegan;
    this.numSeats = spot.numSeats;
    this.canUseGoToCoupon = spot.canUseGoToCoupon;
    this.goToCouponStyle = spot.goToCouponStyle;
    this.shareUrl = spot.shareUrl;
    this.linkUrl = spot.linkUrl;
    this.provider = spot.provider;
    this.reserve = spot.reserve ||
      {
        linkUrl: spot.linkUrl,
        linkWord: spot.linkWord,
      };
    this.spotPlanningDetail = spot.spotPlanningDetail;
    this.informationText = spot.informationText;
  }
}
